module.exports = __webpack_public_path__ + "img/body.188a09be.svg";